import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading.service';
import { environment } from 'src/environments/environment';

const API_MAIN = environment.security + environment.host + environment.version + environment.typeService;


@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private excludedUrls: string[] = [
    API_MAIN + "user-api/get-menu-by-user",
    API_MAIN + "company-parameters-api/get-company-data",
    API_MAIN + "item-api/get-all",
    API_MAIN + "item-discounts-api/get-all",
    API_MAIN + "item-api/get-by-id",
    API_MAIN + "item-discounts-api/get-by-id",
    API_MAIN + "user-api/get-all",
    API_MAIN + "user-role-api/get-all-by-user",
    API_MAIN + "user-api/get-by-id",
    API_MAIN + "user-profile-api/get-all-by-user",
    API_MAIN + "user-role-api/get-all",
    API_MAIN + "user-profile-api/get-all",
    API_MAIN + "company-api/get-all",
    API_MAIN + "company-api/update-by-id-status",
    API_MAIN + "company-parameters-api/get-company-parameters",
    API_MAIN + "profile-api/get-all",
    API_MAIN + "profile-api/get-by-id",
    API_MAIN + "profile-menu-api/get-all-by-profile",
    API_MAIN + "profile-action-api/get-all-by-profile",
    API_MAIN + "user-api/sync",
    API_MAIN + "item-type-api/get-all",
    API_MAIN + "item-type-api/get-by-id",
    API_MAIN + "inventory-movements-api/get-all",
    API_MAIN + "movement-type-api/get-all",
    API_MAIN + "bank-api/get-all",
    API_MAIN + "bank-api/get-by-id",
    API_MAIN + "movement-type-api/get-by-id",
    API_MAIN + "inventory-movements-api/get-by-id",
    API_MAIN + "user-api/update-status",
    API_MAIN + "preapproved-client-api/get-all",
    API_MAIN + "mid/get-all",
    API_MAIN + "mid/get-by-id",
    API_MAIN + "bank-api/summary",
  ];

  constructor(private loadingService: LoadingService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {


    if (this.isUrlExcluded(request.url)) {
      return next.handle(request);
    }

    this.loadingService.show();
    return next.handle(request).pipe(
      finalize(() => {
        this.loadingService.hide();
      })
    );
  }

  private isUrlExcluded(url: string): boolean {
    return this.excludedUrls.some(excludedUrl => url.startsWith(excludedUrl));
  }
}
